export const useCamelToCapitalization = (camel) => camel.replace(/([A-Z])/g, (group) => ` ${group}`).toUpperCase()
